<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'rolesCrud'"
          :crudName="$t('role.crud.title')"
          :newText="$t('role.crud.newButton')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="$hasAbility('rbac.gerenciar')"
          :enableEdit="$hasAbility('rbac.gerenciar')"
          :enableDelete="$hasAbility('rbac.gerenciar')"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "rolesTable",
      columns: ["id", "name", "status", "actions"],
      tableData: ["id", "name", "status"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t("role.crud.idColumn"),
          name: this.$t("role.crud.nameColumn"),
          status: this.$t("common.status"),
          actions: this.$t("common.actions"),
        },
        sortable: ["id", "name"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: this.$t("role.crud.filterByText"),
          defaultOption: this.$t("role.crud.selectOptionText"),
        },
        listColumns: {},
        templates: {
          status: function (h, row) {
            return row.status
              ? h("span", { class: "badge badge-success" }, this.$t("common.active"))
              : h("span", { class: "badge badge-danger" }, this.$t("common.inactive"));
          },
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this),
          );
        },
      },
      endPoint: "roles",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
